export enum AuthState {
    Idle = "idle",
    MsalLogin = "msalLogin",
    MsalRedirectHandle = "msalRedirectHandle",
    MainTokenRequest = "mainTokenRequest",
    LoggedOut = "loggedOut",
    Error = "error",
}
